import { DataService } from '../dataService/dataService';

export const checkPaymentStatus = async (transactionId, chargeId, paymentStatus) => {
  try {
    const params = new URLSearchParams({
      charge_id: chargeId,
      payment_status: paymentStatus,
      transaction_id: transactionId,
    });
    console.log('Params', params.toString());
    const url = `/naka/updatePayment?${params.toString()}`;
    console.log('URL', url);
    const response = await DataService.get(url);
    console.log('Response', response);
    return {
      success: response.data.paymentData?.status === 'COMPLETED',
      message: response.data?.message,
      paymentMethod: response.data.paymentData?.payment?.method,
      status: response.data.paymentData?.status,
      paymentData: response.data?.paymentData,
    };
  } catch (error) {
    if (error.response) {
      throw new Error(error.response?.data?.message || 'Payment verification failed');
    }
    throw new Error('Unable to connect to payment service');
  }
};
